import React, { useEffect, useState, useMemo } from 'react'
import { Card, CardBody, CardHeader, Container } from 'reactstrap';
import BreadCrumb from '../Common/BreadCrumb';
import { Row, Col, Button } from 'reactstrap'
import { MaterialReactTable } from 'material-react-table';
import { ToastContainer, toast } from 'react-toastify';
import { MenuItem, Box } from "@mui/material";
import { InvoiceColumns } from './Constant/LightWeightColoumn';
import { useInvoiceData } from './Constant/Invoicedata';
import { PAGE_TITLES } from '../Common/constants';
function LightWeightInvoice() {
    const [loading, setLoading] = useState('false');
    const customerId = localStorage.getItem("customerId");
    const { invoiceDataForCustomer } = useInvoiceData(customerId, setLoading);
    return (
        <React.Fragment>
            <div id='csms' className='page-content'>
                <Container fluid>
                    <BreadCrumb title={PAGE_TITLES.CUSTOMER_INVOICE}  pageTitle={PAGE_TITLES.INVOICE}/>
                    <ToastContainer position='top-center' />
                    <Row>
                        <Col lg={12}>
                            <div className="listingjs-table " id="customerList">
                                <Card>
                                </Card>
                                <Card>
                                    <CardBody>
                                        <div className="d-flex justify-content-end mb-3">
                                            <Button className="btn-label me-2 bg-secondary px-5">Pay</Button>
                                        </div>
                                        <Row className="mb-3 mt-1 table-responsive">
                                            {invoiceDataForCustomer ?
                                                <MaterialReactTable
                                                    icons={{
                                                        DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                                    }}
                                                    muiTableHeadCellProps={{
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    }}
                                                    muiTableBodyCellProps={{
                                                        sx: {
                                                            fontFamily: "Inter,sans-serif"
                                                        }
                                                    }}
                                                    columns={InvoiceColumns}
                                                    data={invoiceDataForCustomer}
                                                    enableColumnOrdering
                                                    enableColumnDragging
                                                    enableDensityToggle={false}
                                                    enableTopToolbar={false}
                                                    enableRowActions={true}
                                                    enableColumnActions={true}
                                                    displayColumnDefOptions={{
                                                        'mrt-row-actions': {
                                                            header: '',
                                                            enableHiding: true
                                                        }
                                                    }}
                                                    renderRowActionMenuItems={({ closeMenu, row }) => {

                                                        return [
                                                            <MenuItem
                                                                className='row-options'
                                                                key={row.index}
                                                                onClick={() => {
                                                                    closeMenu();
                                                                }}
                                                            >
                                                                < i className='ri-account-circle-line me-2' />
                                                                View
                                                            </MenuItem>,
                                                            <MenuItem
                                                                className='row-options'
                                                                key={row.index}
                                                                onClick={() => {
                                                                    closeMenu();
                                                                }}
                                                            >
                                                                < i className="ri-download-line me-2" />
                                                                Download
                                                            </MenuItem>,
                                                        ]
                                                    }}
                                                />
                                                : null
                                            }
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default LightWeightInvoice;